/**
 * Cross-MFE bridge event names dispatched from blink-v2 and listened to by the
 * admin MFE (js/ts-apps/admin). The admin MFE cannot be imported across the
 * bundle boundary, so these string literals must be kept in sync by hand with
 * the constants declared in
 * js/ts-apps/admin/src/utils/admin-route-constants.ts.
 */

/**
 * Reset the admin panel to its default landing tab. The URL is authoritative;
 * on receiving this the sidebar resolves the first available tab.
 */
export const ADMIN_RESET_EVENT = 'admin:reset-to-default';

/** Navigate the admin panel to a specific tab (legacy, non-routing path). */
export const ADMIN_NAV_EVENT = 'admin:nav-change';

/** Navigate the admin panel from a command-palette (spotlight) selection. */
export const ADMIN_COMMAND_PALETTE_NAVIGATE_EVENT =
    'admin:command-palette-navigate';
